import {useEffect, useState} from 'react';
import {FormattedMessage} from "react-intl";
import {AvField, AvForm} from "availity-reactstrap-validation";
import {Button, Col, Label, Row, Spinner} from "reactstrap";
import {MdSend} from "react-icons/md";
import {FaArrowRotateRight} from "react-icons/fa6";
import BlockUi from "react-block-ui";
import {isMobile} from "react-device-detect";
import Notify from "@components/noty/notify";
import SubmitButton from "@components/buttons/submitButton";
import {FillRequiredFields} from "@components/noty/fillRequiredFields";
import {urls} from "@api/urls";
import patterns from "@constants/patterns";
import {GetRequest, PostRequest} from "@configs/request";
import "./style.scss";
import {useSelector} from "react-redux";

const Form = () => {
    const {auth} = useSelector(state => state)
    const [isLoadingCaptcha, setIsLoadingCaptcha] = useState(false);
    const [captchaImage, setCaptchaImage] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [key, setKey] = useState(0);


    useEffect(() => {
        getCaptcha();
    }, [])

    const getCaptcha = () => {
        setIsLoadingCaptcha(true);
        GetRequest(urls.web.captcha)
            .then((response) => {
                if (response) {
                    if (response.ok && response.data) {
                        let result = response.data;
                        setCaptchaImage(result.captcha);
                    }
                }
            })
            .finally(() => {
                setIsLoadingCaptcha(false);
            });
    }

    const handleSubmit = (event, values) => {
        const data = {...values}

        setIsSubmitting(true);
        PostRequest(urls.web.ReservationRequest, data).then((response) => {
            if (response) {
                const {ok, data} = response;

                if (ok && data) {
                    setKey(prevState => prevState + 1);
                    Notify('success', 'top-left', <FormattedMessage id="contactRequestSuccessfullySubmitted"/>);
                }
            }
        }).finally(() => {
            setIsSubmitting(false);
            getCaptcha();
        })
    }


    return (
        <div className="contact-request ">


            <AvForm
                key={key}
                onValidSubmit={handleSubmit}
                onInvalidSubmit={FillRequiredFields}
                className="contact-request-form"
            >
                <Row>
                    <Col sm={12} md={6}>
                        <Label className="font-weight-bolder" for="name">
                            <FormattedMessage id="name"/>
                            <i className="fa fa-star-of-life"/>
                        </Label>
                        <div>
                            <AvField
                                name="name"
                                id="name"
                                value={auth.firstName}
                                placeholder={"نام خود را اینجا وارد کنید."}
                                validate={{
                                    required: {value: true, errorMessage: "الزامی می باشد."},
                                    pattern: patterns.persianLetters,
                                    minLength: {
                                        value: 2,
                                        errorMessage: "حروف وارد شده کمتر از تعداد مجاز است."
                                    },
                                    maxLength: {
                                        value: 75,
                                        errorMessage: "حروف وارد شده بیشتر از تعداد مجاز است."
                                    }
                                }}
                            />
                        </div>
                    </Col>
                    <Col sm={12} md={6}>
                        <Label className="font-weight-bolder" for="lastname">
                            <FormattedMessage id="lastName"/>
                            <i className="fa fa-star-of-life"/>
                        </Label>
                        <div>
                            <AvField
                                name="lastname"
                                id="lastname"
                                placeholder={"نام خانوادگی خود را اینجا وارد کنید."}
                                value={auth.lastName}
                                validate={{
                                    required: {value: true, errorMessage: "الزامی می باشد."},
                                    pattern: patterns.persianLetters,
                                    minLength: {
                                        value: 2,
                                        errorMessage: "حروف وارد شده کمتر از تعداد مجاز است."
                                    },
                                    maxLength: {
                                        value: 75,
                                        errorMessage: "حروف وارد شده بیشتر از تعداد مجاز است."
                                    }
                                }}
                            />
                        </div>
                    </Col>

                    <Col sm={12} md={6}>
                        <div className="text-left">
                            <Label className="font-weight-bolder" for="phone">
                                <FormattedMessage id="mobileNumber"/>
                                <i className="fa fa-star-of-life"/>
                            </Label>
                            <AvField
                                name="phone"
                                id="phone"
                                type="phone"
                                value={auth.phone}
                                placeholder={"شماره تماس را اینجا وارد کنید."}
                                validate={{
                                    required: {value: true, errorMessage: "الزامی می باشد."},
                                    pattern: patterns.number(),
                                    minLength: {value: 11, errorMessage: "شماره موبایل 11 رقم دارد."},
                                    maxLength: {value: 11, errorMessage: "شماره موبایل 11 رقم دارد."}
                                }}
                            />
                        </div>
                    </Col>

                    <Col sm={12} md={12}>
                        <div className="text-left">
                            <Label className="font-weight-bolder" for="address">
                                <FormattedMessage id="address"/>
                                <i className="fa fa-star-of-life"/>
                            </Label>
                            <AvField
                                name="address"
                                id="address"
                                placeholder={"آدرس خود را اینجا وارد کنید."}
                                validate={{
                                    required: {value: true, errorMessage: "الزامی می باشد."},
                                }}
                            />
                        </div>
                    </Col>

                    <Col sm={12} md={12}>
                        <Label className="font-weight-bolder" for="description">
                            <FormattedMessage id="description"/>
                            <i className="fa fa-star-of-life"/>
                        </Label>
                        <AvField
                            name="description"
                            id="description"
                            type="description"
                            placeholder={"متن پیام را اینجا وارد کنید."}
                            rows={4}
                            validate={{
                                required: {value: true, errorMessage: "الزامی می باشد."},
                                minLength: {
                                    value: 5,
                                    errorMessage: "حروف وارد شده کمتر از تعداد مجاز است."
                                }
                            }}
                        />
                    </Col>
                </Row>

                <Row className={isMobile ? "flex-column-reverse" : ""}>
                    <Col sm={12} md={6}>
                        <div className="text-left">
                            <Label className="font-weight-bolder" for="mobile">
                                <FormattedMessage id="captcha"/>
                                <i className="fa fa-star-of-life"/>
                            </Label>
                            <AvField
                                name="captcha"
                                id="captcha"
                                type="text"
                                placeholder={"کد امنیتی را اینجا وارد کنید."}
                                validate={{
                                    required: {value: true, errorMessage: "الزامی می باشد."}
                                }}
                            />
                        </div>
                    </Col>

                    <Col sm={12} md={6} className="d-flex align-items-center justify-content-end">
                        <BlockUi tag="div" blocking={isLoadingCaptcha}
                                 loader={<Spinner color="primary" className="reload-spinner"/>}
                                 keepInView>
                            <img src={captchaImage} height="38px"/>

                        </BlockUi>

                        <Button aria-label={".."} color="transparent" className="pr-0" onClick={() => getCaptcha()}
                                disabled={isLoadingCaptcha}>
                            <FaArrowRotateRight size={20}/>
                        </Button>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} md={12}>
                        <SubmitButton
                            isLoading={isSubmitting}
                            icon={<MdSend/>}
                            className="contact-request-form-button"
                        >
                            <FormattedMessage id="send"/>
                        </SubmitButton>
                    </Col>
                </Row>
            </AvForm>
        </div>

    );
};

export default Form;